/* eslint-disable */
// Converts a hex color to RGB
function hexToRgb(hex) {
  hex = hex.replace(/^#/, '');
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;
  return [r, g, b];
}

// Converts RGB to HSL
function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  
  let max = Math.max(r, g, b);
  let min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // No saturation if max equals min
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch(max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }
  
  return [h * 360, s * 100, l * 100];
}

// Converts HSL to HEX
function hslToHex(h, s, l) {
  h = h / 360;
  s = s / 100;
  l = l / 100;
  
  function hue2rgb(p, q, t) {
    if(t < 0) t += 1;
    if(t > 1) t -= 1;
    if(t < 1/6) return p + (q - p) * 6 * t;
    if(t < 1/2) return q;
    if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
    return p;
  }
  
  let r, g, b;
  
  if (s === 0) {
    r = g = b = l; // If there is no saturation, all colors are the same (gray scale)
  } else {
    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }
  
  const toHex = (x) => {
    const hx = Math.round(x * 255).toString(16).padStart(2, '0');
    return hx;
  };
  
  return "#" + toHex(r) + toHex(g) + toHex(b);
}

const baseColors = ['#167050', '#da1020', '#5620a6', '#df0078', '#56a019', '#9925da', '#706418', '#545454', '#2c58a1', '#bc5906', '#7f0162'];

// Generates a specified number of distinct colors based on the base color list
export function generateDistinctColorsFromBase(count) {
  const result = [];
  const baseCount = baseColors.length;

  if (count <= baseCount) {
    // If the required number of colors is less than or equal to the base list, return the first `count` items
    return baseColors.slice(0, count);
  }

  // If more colors are needed, add all base colors first
  for (let i = 0; i < baseCount; i++) {
    result.push(baseColors[i]);
  }

  // Remaining number of colors needed
  const needed = count - baseCount;
  
  // For additional colors, adjust the hue value step by step
  const hueStep = 360 / needed;

  for (let i = 0; i < needed; i++) {
    const baseIndex = i % baseCount;
    const baseHex = baseColors[baseIndex];
    const [r, g, b] = hexToRgb(baseHex);
    let [h, s, l] = rgbToHsl(r, g, b);
    
    // Increment the hue value for each additional color
    h = (h + (hueStep * i)) % 360;
    
    // Optionally, you can also slightly modify the `s` and `l` values.
    // Example: s = Math.min(100, s + (i * 2)); or use a different logic.
    
    const newColor = hslToHex(h, s, l);
    result.push(newColor);
  }

  return result;
}
